import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const company_types = ref([])
const filtered_company_types = ref([])
const company_type_filters = ref({
  name: '',
})

export default function useCompanyTypes() {
  const listCompanyTypes = async () => {
    await axios
      .get('/api/company_types/all')
      .then(function (response) {
        company_types.value = filtered_company_types.value = response.data.data
      })
      .catch(function () {})
  }

  const updateFilters = async () => {
    let filters = toRaw(company_type_filters.value)

    filtered_company_types.value = company_types.value.filter((row) => {
      let company_type = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          company_type[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(company_type_filters.value, () => {
    setTimeout(() => {
      updateFilters()
    }, 250)
  })

  return {
    company_types: computed(() => company_types.value),
    filtered_company_types: computed(() => filtered_company_types.value),
    company_type_filters,
    listCompanyTypes,
  }
}
